<div
  *ngIf="geofenceBlocked; else authExperience"
  class="geofence-blocked-host"
>
  <app-geofence-blocked></app-geofence-blocked>
</div>

<ng-template #authExperience>
<div
  class="aya-page"
  [class.verify-mode]="modalStep === 'code' || modalStep === 'phone-register' || modalStep === 'mfa-code' || modalStep === 'email-link-confirm' || showSignedInProfile || isDeepLinkPending"
  [class.auth-modal-open]="!isLoggedIn && !isRedirecting && (modalStep === 'email' || modalStep === 'password')"
  [class.redirecting]="isRedirecting"
>
  <header class="aya-header" *ngIf="!isRedirecting">
    <a class="brand-link" href="/" aria-label="Health Exam home">
      <img
        class="brand-logo"
        src="assets/images/healthexam-logo.png"
        alt="Health Exam"
      />
    </a>
    <div
      class="header-actions"
      *ngIf="sessionReady && modalStep !== 'code' && modalStep !== 'email-link-confirm' && !isDeepLinkPending && !showSignedInProfile"
    >
      <button
        type="button"
        class="link-btn"
        [class.active]="authMode === 'login'"
        (click)="openModal('login')"
      >
        Log in
      </button>
      <button
        type="button"
        class="signup-btn"
        [class.active]="authMode === 'signup'"
        (click)="openModal('signup')"
      >
        Sign up for free
      </button>
    </div>
    <div
      class="header-actions"
      *ngIf="sessionReady && showSignedInProfile && deepLinkReturnUrl"
    >
      <button type="button" class="signup-btn" (click)="returnToDeepLinkApp()">
        Return to app
      </button>
    </div>
  </header>

  <!-- SMS 2FA management deep-link only -->
  <main class="verify-page" *ngIf="showSignedInProfile">
    <div class="verify-panel signed-in-panel">
      <h1 class="verify-title">SMS two-factor authentication</h1>
      <p class="verify-subtitle">
        {{
          smsMfaStatusLoading
            ? 'Checking status…'
            : smsMfaEnabled
              ? 'SMS two-factor authentication is enabled.'
              : 'SMS two-factor authentication is not enabled.'
        }}
      </p>
      <p class="verify-subtitle security-hint" *ngIf="smsMfaStatusMessage">
        {{ smsMfaStatusMessage }}
      </p>
      <button
        *ngIf="!smsMfaEnabled && !smsMfaStatusLoading"
        type="button"
        class="primary-pill-btn"
        [disabled]="smsMfaActionInProgress"
        (click)="enableSmsMfa()"
      >
        {{ smsMfaActionInProgress ? 'Please wait...' : 'Enable SMS 2FA' }}
      </button>
      <button
        *ngIf="smsMfaEnabled && !smsMfaStatusLoading"
        type="button"
        class="primary-pill-btn secondary-action"
        [disabled]="smsMfaActionInProgress"
        (click)="disableSmsMfa()"
      >
        {{ smsMfaActionInProgress ? 'Please wait...' : 'Disable SMS 2FA' }}
      </button>
      <div *ngIf="error" class="modal-error" role="alert">{{ error }}</div>
    </div>
  </main>

  <!-- Social OAuth: redirect to IdP or finishing return from Google / Apple -->
  <main
    class="verify-page"
    *ngIf="
      socialSignInEnabled &&
      !isLoggedIn &&
      (isRedirecting || (isDeepLinkPending && inProgress)) &&
      modalStep === 'none'
    "
  >
    <div class="verify-panel deep-link-loader" aria-live="polite">
      <div class="auth-spinner" role="status" aria-label="Signing in"></div>
      <p class="verify-subtitle">Signing you in…</p>
    </div>
  </main>

  <!-- SMS MFA: register phone (login or profile enable) -->
  <main
    class="verify-page"
    *ngIf="(!isLoggedIn && !isDeepLinkPending && modalStep === 'phone-register') || (enablingSmsMfa && modalStep === 'phone-register')"
  >
    <form class="verify-panel" (ngSubmit)="submitPhoneRegistration()" novalidate>
      <h1 class="verify-title">
        {{ enablingSmsMfa ? 'Enable SMS two-factor authentication' : 'Set up SMS verification' }}
      </h1>
      <p class="verify-subtitle" *ngIf="enablingSmsMfa">
        Enter your mobile number. We will verify it with a one-time code before
        enabling SMS two-factor authentication on your account.
      </p>
      <p class="verify-subtitle" *ngIf="!enablingSmsMfa">
        Your account is enrolled in SMS two-factor authentication. Enter your
        mobile number to receive a verification code. Include country code with
        a space, e.g. +92 3155432768 or +1 5555551234.
      </p>

      <input
        class="pill-input verify-code-input"
        type="tel"
        name="phoneNumber"
        [(ngModel)]="phoneNumber"
        autocomplete="tel"
        placeholder="+92 3155432768"
        autofocus
      />

      <div *ngIf="error" class="modal-error" role="alert">{{ error }}</div>

      <button
        class="primary-pill-btn"
        type="submit"
        [disabled]="inProgress || !phoneNumber"
      >
        {{ inProgress ? 'Please wait...' : (enablingSmsMfa ? 'Continue' : 'Send code') }}
      </button>

      <button
        *ngIf="enablingSmsMfa"
        type="button"
        class="text-action verify-different muted"
        style="margin-top: 16px"
        [disabled]="inProgress"
        (click)="cancelSmsMfaEnable()"
      >
        Cancel
      </button>
    </form>
  </main>

  <!-- SMS MFA: enter code sent to phone -->
  <main
    class="verify-page"
    *ngIf="(!isLoggedIn && !isDeepLinkPending && modalStep === 'mfa-code') || (enablingSmsMfa && modalStep === 'mfa-code')"
  >
    <form class="verify-panel" (ngSubmit)="verifyOTP()" novalidate>
      <h1 class="verify-title">Verify your phone</h1>
      <p class="verify-subtitle">
        Enter the verification code we sent to
        {{ partialPhone || 'your phone' }}
      </p>

      <input
        class="pill-input verify-code-input"
        type="text"
        name="otp"
        [(ngModel)]="otp"
        inputmode="numeric"
        autocomplete="one-time-code"
        maxlength="8"
        placeholder="Code"
        autofocus
      />

      <div *ngIf="error" class="modal-error" role="alert">{{ error }}</div>

      <button
        class="primary-pill-btn"
        type="submit"
        [disabled]="inProgress || !otp"
      >
        {{ inProgress ? 'Please wait...' : (enablingSmsMfa ? 'Enable SMS 2FA' : 'Continue') }}
      </button>

      <button
        *ngIf="enablingSmsMfa"
        type="button"
        class="text-action verify-different muted"
        style="margin-top: 16px"
        [disabled]="inProgress"
        (click)="cancelSmsMfaEnable()"
      >
        Cancel
      </button>
    </form>
  </main>

  <!-- Cross-browser: confirm email to finish passwordless sign-in from the link. -->
  <main
    class="verify-page"
    *ngIf="!isLoggedIn && !isDeepLinkPending && modalStep === 'email-link-confirm'"
  >
    <form class="verify-panel" (ngSubmit)="completeEmailLinkWithConfirmedEmail()" novalidate>
      <h1 class="verify-title">Finish signing in</h1>
      <p class="verify-subtitle">
        Enter the email address where we sent your sign-in link.
      </p>

      <div *ngIf="error" class="modal-error" role="alert">{{ error }}</div>

      <input
        class="pill-input verify-code-input"
        type="email"
        name="email"
        [(ngModel)]="email"
        placeholder="Email address"
        autocomplete="email"
        required
      />

      <button
        type="submit"
        class="pill-btn primary"
        [disabled]="inProgress"
      >
        {{ inProgress ? 'Please wait...' : 'Continue' }}
      </button>
    </form>
  </main>

  <!-- Full-page verification (email OTP or passwordless link) -->
  <main class="verify-page" *ngIf="(!isLoggedIn && !isDeepLinkPending && modalStep === 'code') || (enablingSmsMfa && modalStep === 'code')">
    <form class="verify-panel" (ngSubmit)="verifyOTP()" novalidate>
      <h1 class="verify-title">Check your inbox</h1>
      <p class="verify-subtitle" *ngIf="enablingSmsMfa">
        Confirm your email to continue setting up SMS two-factor authentication.
        Enter the verification code we just sent to
        {{ email }}
      </p>
      <p class="verify-subtitle" *ngIf="!enablingSmsMfa && showPasswordlessInboxUi">
        We sent a sign-in link to <strong>{{ email }}</strong>.
        Open the email on this or any other device and tap the link to finish signing in.
      </p>
      <p class="verify-subtitle" *ngIf="!enablingSmsMfa && !showPasswordlessInboxUi">
        Enter the verification code we just sent to
        {{ email }}
      </p>

      <input
        *ngIf="!showPasswordlessInboxUi || enablingSmsMfa"
        class="pill-input verify-code-input"
        type="text"
        name="otp"
        [(ngModel)]="otp"
        inputmode="numeric"
        autocomplete="one-time-code"
        maxlength="8"
        placeholder="Code"
        autofocus
      />

      <div *ngIf="error" class="modal-error" role="alert">{{ error }}</div>

      <button
        *ngIf="!showPasswordlessInboxUi || enablingSmsMfa"
        class="primary-pill-btn"
        type="submit"
        [disabled]="inProgress || !otp"
      >
        {{ inProgress ? "Please wait..." : "Continue" }}
      </button>

      <button
        type="button"
        class="text-action verify-email-link-fallback"
        *ngIf="numericGoogleEmailOtp && !showPasswordlessInboxUi && !enablingSmsMfa"
        [disabled]="inProgress"
        (click)="loginWithEmailLink()"
      >
        Haven't received the code? Send me a login link instead.
      </button>

      <button
        type="button"
        class="text-action verify-resend"
        [disabled]="secondsCountdown > 0 || inProgress"
        (click)="resendCode()"
      >
        <ng-container *ngIf="secondsCountdown === 0">
          {{ showPasswordlessInboxUi && !enablingSmsMfa ? 'Resend link' : 'Resend email' }}
        </ng-container>
        <ng-container *ngIf="secondsCountdown > 0">
          {{ showPasswordlessInboxUi && !enablingSmsMfa ? 'Resend link in' : 'Resend email in' }}
          {{ secondsCountdown }}s
        </ng-container>
      </button>

      <button
        *ngIf="enablingSmsMfa"
        type="button"
        class="text-action verify-different muted"
        [disabled]="inProgress"
        (click)="cancelSmsMfaEnable()"
      >
        Cancel
      </button>

      <button
        *ngIf="!enablingSmsMfa"
        type="button"
        class="text-action verify-different muted"
        (click)="useAnotherAccount()"
      >
        Use a different email
      </button>
    </form>
  </main>
</div>

<!-- Auth popup for email / password only -->
<div
  class="auth-backdrop"
  *ngIf="!isLoggedIn && !isRedirecting && (modalStep === 'email' || modalStep === 'password')"
  role="presentation"
>
  <div
    class="auth-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="authModalTitle"
  >
    <button
      type="button"
      class="auth-modal-close"
      aria-label="Close and return to Health Exam chat"
      (click)="dismissAuthToHealthChat()"
    >
      <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
        <path
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          d="M6 6l12 12M18 6L6 18"
        />
      </svg>
    </button>
    <form #loginForm="ngForm" (ngSubmit)="onSubmit()" novalidate>
      <ng-container *ngIf="modalStep === 'email'">
        <h2 id="authModalTitle" class="modal-title">Log in or Sign up</h2>
        <p class="modal-subtitle">
          Log in to continue your health conversations.
        </p>

        <div *ngIf="error" class="modal-error" role="alert">{{ error }}</div>

        <div class="social-sign-in-section">
        <button
          type="button"
          class="social-btn"
          [disabled]="!socialSignInEnabled || inProgress"
          (click)="onSocialClick('google')"
        >
          <svg class="social-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path
              fill="#4285F4"
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            />
            <path
              fill="#34A853"
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            />
            <path
              fill="#FBBC05"
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            />
            <path
              fill="#EA4335"
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            />
          </svg>
          Continue with Google
        </button>
        <button
          type="button"
          class="social-btn"
          [disabled]="!socialSignInEnabled || inProgress"
          (click)="onSocialClick('apple')"
        >
          <svg class="social-icon apple" viewBox="0 0 24 24" aria-hidden="true">
            <path
              fill="currentColor"
              d="M16.365 1.43c0 1.14-.42 2.2-1.22 3.03-.9.94-2.1 1.53-3.25 1.44-.14-1.1.4-2.25 1.2-3.12.9-.95 2.25-1.62 3.27-1.35zm4.54 16.34c-.4.92-.87 1.77-1.42 2.55-.75 1.06-1.36 1.8-2.25 1.82-.8.02-1.06-.48-2.2-.48s-1.45.46-2.25.5c-.88.04-1.55-.8-2.3-1.86-1.54-2.16-2.72-6.1-1.14-8.77.78-1.33 2.05-2.17 3.47-2.19.86-.02 1.67.58 2.2.58.52 0 1.5-.72 2.53-.61.43.02 1.64.17 2.42 1.3-.06.04-1.44.84-1.42 2.52.02 2 1.74 2.66 1.76 2.67-.02.06-.27.94-.6 1.87z"
            />
          </svg>
          Continue with Apple
        </button>

        <div class="or-divider"><span>OR</span></div>
        </div>

        <input
          class="pill-input"
          type="email"
          name="email"
          [(ngModel)]="email"
          #emailField="ngModel"
          required
          email
          placeholder="Email address"
          autocomplete="email"
          autofocus
        />
        <div
          class="field-error"
          *ngIf="emailField.touched && emailField.errors?.['email']"
        >
          Enter a valid email address
        </div>

        <button class="primary-pill-btn" type="submit" [disabled]="inProgress">
          {{ inProgress ? "Please wait..." : "Continue" }}
        </button>
      </ng-container>

      <ng-container *ngIf="modalStep === 'password'">
        <h2 id="authModalTitle" class="modal-title">Enter your password</h2>
        <p class="modal-subtitle">{{ email }}</p>
        <div *ngIf="error" class="modal-error" role="alert">{{ error }}</div>
        <input
          class="pill-input"
          type="password"
          name="password"
          [(ngModel)]="password"
          required
          placeholder="Password"
          autocomplete="current-password"
          autofocus
        />
        <button class="primary-pill-btn" type="submit" [disabled]="inProgress">
          {{ inProgress ? "Please wait..." : "Sign In" }}
        </button>
        <button type="button" class="text-action" (click)="useAnotherAccount()">
          Use a different email
        </button>
      </ng-container>
    </form>
  </div>
</div>
</ng-template>
